// pages/About.js
import React, { useEffect } from 'react';
import Carousel from '../components/Carousel';

function AboutAMZ() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="about-page" >
      {/* Hero Section */}
      <div style={{
        padding: '80px 0 40px',
        textAlign: 'center',
        backgroundImage: 'url(/images/cover.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        position: 'relative',
        width: '100%',
        marginLeft: 'calc(-50vw + 50%)',
        minHeight: '400px'
      }}>
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
          zIndex: 1
        }}></div>
        <div className="container" style={{ position: 'relative', zIndex: 2, padding: '0 20px' }}>

        <style jsx>{`
          @media (max-width: 768px) {
            .about-page > div:first-child {
              padding: 60px 0 30px !important;
              min-height: 300px !important;
            }
            .about-page h1 {
              font-size: 2.5rem !important;
            }
            .about-page h3 {
              font-size: 1.5rem !important;
            }
          }
        `}</style>

        <h1 style={{
          fontSize: '3.5rem',
          marginBottom: '20px',
          background: 'linear-gradient(135deg, var(--primary-orange), var(--secondary-orange))',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
          direction: 'ltr'
        }}>
          ⴰⵎⵣⵉⵣⵣⵍ ⴰⵏⴰⵎⵓⵔ ⵏ ⵓⵙⴱⴷⴷⵉ ⵏ ⵜⴽⵕⴹⵉ ⵜⴰⵎⵓⵟⵟⵓⵏⵜ ⵎⴳⴰⵍ ⵜⵉⵡⵜⵎⵉⵏ ⴷ ⵜⵔⴱⴰⵜⵉⵏ
        </h1>

        <h3 style={{
          fontSize: '2rem',
          marginBottom: '20px',
          fontWeight: '600',
          lineHeight: '1.6',
          direction: 'ltr'
        }}>
        ⴰⴱⵔⴱⴰⵢⵢⵓⵕ ⴰⵎⵓⵟⵟⵓⵏ ⵉⴼⵙⵙⵜⴰⵏ ⵉⵙⴷⵉⴷⴷⵉⵏ ⴰⵎⵓⵏ
        </h3>

        <div style={{
          background: 'var(--secondary-black)',
          padding: '20px 30px',
          borderRadius: '15px',
          borderRight: '4px solid var(--primary-orange)',
          marginBottom: '25px',
          direction: 'ltr'
        }}>
          <p style={{ fontSize: '1.3rem', marginBottom: '10px' }}>
          <img src="/images/calandarv.png" className="tab-icon3-img" /> <strong>ⴰⵣⵎⵣ:</strong> 25 ⵏⵓⵡⴰⵏⴱⵉⵔ – 10 ⴷⵓⵊⴰⵏⴱⵉⵔ 2025
          </p>
          <p style={{ fontSize: '1.3rem' }}>
            <img src="/images/duration.png" className="tab-icon3-img" /> <strong>ⵜⴰⵙⵓⵍⵜ :</strong> 16 ⵏ ⵡⴰⵙⵙ
          </p>
        </div>
        </div>
      </div>

      {/* Main Content */}
      <div style={{ background: 'var(--secondary-black)', padding: '60px 0', direction: 'ltr' }}>
        <div className="container">
          {/* Campaign Introduction */}
          <div style={{
            background: 'var(--primary-black)',
            padding: '50px 40px',
            borderRadius: '20px',
            marginBottom: '50px',
            border: '2px solid rgba(255, 107, 53, 0.3)',
            direction: 'ltr'
          }}>
            <h2 style={{
              fontSize: '2.5rem',
              marginBottom: '25px',
              color: 'var(--primary-orange)',
              textAlign: 'center',
              direction: 'ltr'
            }}>
              ⴰⴱⵔⴱⴰⵢⵢⵓⵕ ⴰⵎⵓⵟⵟⵓⵏ ⵉⴼⵙⵙⵜⴰⵏ ⵉⵙⴷⵉⴷⴷⵉⵏ ⴰⵎⵓⵏ
            </h2>

            <div style={{
              fontSize: '1.2rem',
              lineHeight: '2',
              color: 'var(--text-light)',
              direction: 'ltr',
              textAlign:'left'
            }}>

            <p style={{ marginBottom: '20px' }}>
        ⵜⵉⴽⵕⴹⵉ ⵎⴳⴰⵍ ⵜⵉⵡⵜⵎⵉⵏ ⴷ ⵜⵔⴱⴰⵜⵉⵏ ⴷ <strong style={{ color: 'var(--primary-orange)' }}>ⵜⵉⵕⵥⵉ ⵏ ⵉⵣⵔⴼⴰⵏ ⵏ ⵓⴼⴳⴰⵏ ⴱⴰⵀⵔⴰ ⵉⵣⵓⵣⵣⵔⵏ ⴳ ⵓⵎⴰⴹⴰⵍ</strong>. ⵍⵍⵉⵖ ⴰⵔ ⵜⴻⵜⵜⵎⵏⴰⵍⴰ ⵢⴰⵜ ⵜⵎⵖⴰⵔⵜ ⵙⴳ ⴽⵕⴰⴹⵜ, ⵢⴰⵜ ⵜⵡⵉⵍⴰ ⵙⴳ ⵜⵡⵉⵍⴰⵜⵉⵏ ⵏⵏⵙ, ⵢⴰⵜ ⵜⵉⴽⴽⵍⵜ ⴳ ⵜⵓⴷⵔⵜ ⵙ ⵜⴷⵔⵙⵉ.
      </p>

      <p style={{ marginBottom: '20px' }}>
        ⴷ ⴳ ⵉⴷⴷⵖ ⵜⵍⵍⴰ ⵜⵣⵣⵉⴳⵣⵜ ⵜⵓⴷⵔⵉⴼⵜ ⵏ ⵜⵉⵜⵉⴽⵏⵓⵍⵓⵊⵉⵢⵉⵏ ⵜⵉⵜⵔⴰⵔⵉⵏ ⴷ ⵉⵎⴰⵙⵙⵏ ⵏ ⵓⵎⵢⴰⵡⴰⴹ ⴰⵏⴰⵎⵓⵏ, <strong style={{ color: 'var(--primary-orange)' }}>ⵉⵎⵉⵔⵉⵡ ⵓⵙⴰⵢⵔⴰⵔ ⵏ ⵜⴽⵕⴹⵉ ⵎⴳⴰⵍ ⵜⵉⵡⵜⵎⵉⵏ ⴷ ⵜⵔⴱⴰⵜⵉⵏ</strong> ⴰⴼⴰⴷ ⴰⴷ ⵜⴰⵙⵉ ⵜⵉⵡⵉⵍⴰⵜⵉⵏ ⵜⵉⵎⵓⵟⵟⵓⵏⵉⵏ ⵜⵉⵎⴰⵢⵏⵓⵜⵉⵏ ⵉⴽⵔⵙⵏ, ⵜⴰⵖⵓⵍ ⵜⴰⵜⵉⴽⵏⵓⵍⵓⵊⵉⵜ ⴰⵔ ⵜⵜⴰⵡⵙ ⴳ ⵓⵙⵙⵀⵡⵏ ⵏ ⵜⴽⵕⴹⵉ ⴰⴷ ⴷ ⵓⵙⴳⴳⵓⵜ ⵏ ⵉⴷⵔⵉⵣⵏ ⵏⵏⵙ ⵉⵏⵉⵎⴰⵏⵏ ⴷ ⵉⵏⴰⵎⵓⵏⵏ ⴷ ⵓⵍⴳⵉⵏⵏ.
      </p>

            </div>
          </div>

          {/* Alarming Statistics */}
          <div style={{ marginBottom: '60px', direction: 'ltr' }}>
            <h3 style={{
              fontSize: '2.5rem',
              marginBottom: '35px',
              textAlign: 'center',
              color: 'var(--white)',
              direction: 'ltr'
            }}>
              ⵜⵉⵎⵓⵛⴰ ⵜⵉⵎⴰⴹⵍⴰⵏⵉⵏ ⵙⵖⵉⵍⵉⴼⵏⵉⵏ
            </h3>

            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
              gap: '25px',
              marginBottom: '40px'
            }}>
              <div style={{
                background: 'var(--primary-black)',
                padding: '35px',
                borderRadius: '15px',
                textAlign: 'center',
                border: '2px solid var(--primary-orange)',
                direction: 'ltr'
              }}>
                <div style={{
                  fontSize: '4rem',
                  fontWeight: '700',
                  color: 'var(--primary-orange)',
                  marginBottom: '15px'
                }}>
                  16-58%
                </div>
                <p style={{ fontSize: '1.15rem', lineHeight: '1.7' }}>
                  ⴰⵙⵖⵍ ⵏ ⵓⵣⵓⵣⵣⵔ ⵏ ⵜⴽⵕⴹⵉ ⵜⴰⵎⵓⵟⵟⵓⵏⵜ ⴳ ⵓⵎⴰⴹⴰⵍ
                </p>
              </div>

              <div style={{
                background: 'var(--primary-black)',
                padding: '35px',
                borderRadius: '15px',
                textAlign: 'center',
                border: '2px solid var(--primary-orange)',
                direction: 'ltr'
              }}>
                <div style={{
                  fontSize: '4rem',
                  fontWeight: '700',
                  color: 'var(--primary-orange)',
                  marginBottom: '15px'
                }}>
                  14-16
                </div>
                <p style={{ fontSize: '1.15rem', lineHeight: '1.7' }}>
              ⴰⵡⵜⴰⵢ ⵏⵏⴰ ⵖ ⵙⵙⵏⵜⴰⵢⵏⵜ ⵜⵔⴱⴰⵜⵉⵏ ⴷⴰ ⵜⵜⵎⵏⴰⵍⴰⵏⵜ ⴰⵥⵍⵍⴻⵍ ⴰⵍⵉⴽⵟⵕⵓⵏⵉ
                </p>
              </div>

              <div style={{
                background: 'var(--primary-black)',
                padding: '35px',
                borderRadius: '15px',
                textAlign: 'center',
                border: '2px solid var(--primary-orange)',
                direction: 'ltr'
              }}>
                <div style={{
                  fontSize: '4rem',
                  fontWeight: '700',
                  color: 'var(--primary-orange)',
                  marginBottom: '15px'
                }}>
                  60%
                </div>
                <p style={{ fontSize: '1.15rem', lineHeight: '1.7' }}>
                  ⵏ ⵜⵡⵜⵎⵉⵏ ⴳ ⵜⵎⵏⴰⴹⵜ ⵜⴰⵄⵕⴰⴱⵜ ⴰⴷ ⵉⵜⵜⵎⵏⴰⵍⴰⵏ ⵜⵉⵡⵉⵍⴰⵜⵉⵏ ⵏ ⵜⴽⵕⴹⵉ ⵜⴰⵎⵓⵟⵟⵓⵏⵜ
                </p>
              </div>

              <div style={{
                background: 'var(--primary-black)',
                padding: '35px',
                borderRadius: '15px',
                textAlign: 'center',
                border: '2px solid var(--primary-orange)',
                direction: 'ltr'
              }}>
                <div style={{
                  fontSize: '4rem',
                  fontWeight: '700',
                  color: 'var(--primary-orange)',
                  marginBottom: '15px'
                }}>
                  95%
                </div>
                <p style={{ fontSize: '1.15rem', lineHeight: '1.7' }}>
                  ⵙⴳ ⵜⵓⵎⴰⵢⵜ ⵏ "ⵓⵙⵃⵍⵍⴻⵍ ⵉⵖⴱⴰⵏ" ⴰⵡⵙⵢⴰⵏ ⵉⵡⴰⵜⵜⵙ ⵜⵉⵡⵜⵎⵉⵏ
                </p>
              </div>

              <div style={{
                background: 'var(--primary-black)',
                padding: '35px',
                borderRadius: '15px',
                textAlign: 'center',
                border: '2px solid var(--primary-orange)',
                direction: 'ltr'
              }}>
                <div style={{
                  fontSize: '4rem',
                  fontWeight: '700',
                  color: 'var(--primary-orange)',
                  marginBottom: '15px'
                }}>
                  44%
                </div>
                <p style={{ fontSize: '1.15rem', lineHeight: '1.7' }}>
                  ⵙⴳ ⵡⴰⴷⴷⴰⴷⵏ ⵏ ⵜⴽⵕⴹⵉ ⵜⴰⵎⵓⵟⵟⵓⵏⵜ ⴰⵔ ⵜⵜⵓⵖⵓⵍⵏ ⵖⵔ ⵜⴽⵕⴹⵉ ⵜⴰⵏⵉⵍⴰⵡⵜ
                </p>
              </div>

              <div style={{
                background: 'var(--primary-black)',
                padding: '35px',
                borderRadius: '15px',
                textAlign: 'center',
                border: '2px solid var(--primary-orange)',
                direction: 'ltr'
              }}>
                <div style={{
                  fontSize: '4rem',
                  fontWeight: '700',
                  color: 'var(--primary-orange)',
                  marginBottom: '15px'
                }}>
                  1.5M
                </div>
                <p style={{ fontSize: '1.15rem', lineHeight: '1.7' }}>
                  ⵎⵍⵢⵓⵏ ⵏ ⵜⵎⵖⴰⵔⵜ ⵜⴰⵎⵖⵔⵉⴱⵉⵜ ⴰⵔ ⵜⵜⵎⵏⴰⵍⴰⵏⵜ ⵜⵉⴽⵕⴹⵉ ⵜⴰⵎⵓⵟⵟⵓⵏⵜ ⴽⵓ ⴰⵙⴳⴳⵯⴰⵙ
                </p>
              </div>
            </div>
          </div>

          {/* Most Common Forms */}
          <div style={{ marginBottom: '60px' }}>
            <h3 style={{
              fontSize: '2.5rem',
              marginBottom: '35px',
              textAlign: 'center',
              color: 'var(--white)'

            }}>
              ⵜⵉⵡⵉⵍⴰⵜⵉⵏ ⵏ ⵜⴽⵕⴹⵉ ⵜⴰⵎⵓⵟⵟⵓⵏⵜ ⵉⵜⵜⵓⵣⵓⵣⵣⵔⵏ ⴰⵟⵟⴰⵚ
            </h3>

            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
              gap: '25px'
            }}>
              {[
                { percentage: '67%', text: 'ⴰⵙⵉⵙⵙⵏ ⴷ ⵓⵣⵓⵣⵣⵔ ⵏ ⵓⵎⵍⴰⵏ ⵏ ⵜⴽⵔⴽⴰⵙ' },
                { percentage: '66%', text: 'ⴰⵥⵍⵍⴻⵍ ⴰⵍⵉⴽⵟⵕⵓⵏⵉ' },
                { percentage: '65%', text: 'ⴰⵡⵏⵏⵉ ⵏ ⵓⴽⵙⴰⵏ' },
              ].map((item, index) => (
                <div key={index} style={{
                  background: 'var(--primary-black)',
                  padding: '30px',
                  borderRadius: '15px',
                  border: '2px solid rgba(255, 107, 53, 0.3)',
                  textAlign: 'center',
                  direction: 'ltr'
                }}>
                  {item.percentage && (
                    <div style={{
                      fontSize: '3rem',
                      fontWeight: '700',
                      color: 'var(--primary-orange)',
                      marginBottom: '15px'
                    }}>
                      {item.percentage}
                    </div>
                  )}
                  <p style={{ fontSize: '1.1rem', lineHeight: '1.7' }}>
                    {item.text}
                  </p>
                </div>
              ))}
            </div>

            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
              gap: '25px',
              marginTop:'25px'
            }}>
              {[
                { percentage: '', text: 'ⴰⵣⵓⵅⵅⵓ ⴷ ⵜⴰⴷⴱⵔⵜ ⵜⴰⵍⵉⴽⵟⵕⵓⵏⵉⵜ' },
                { percentage: '', text: 'ⵜⴰⵙⴱⴱⴰⴱⵜ ⵜⴰⵍⵉⴽⵟⵕⵓⵏⵉⵜ ⴳ ⵉⵡⴷⴰⵏ' },
                { percentage: '', text: 'ⴰⵙⵃⵍⵍⴻⵍ ⵉⵖⴱⴰⵏ ⵙ ⵜⵖⵉⵙⵜ ⵜⵉⵎⵍⵥⵉⵜ' }
              ].map((item, index) => (
                <div key={index} style={{
                  background: 'var(--primary-black)',
                  padding: '30px',
                  borderRadius: '15px',
                  border: '2px solid rgba(255, 107, 53, 0.3)',
                  textAlign: 'center',
                  direction: 'ltr'
                }}>
                  {item.percentage && (
                    <div style={{
                      fontSize: '3rem',
                      fontWeight: '700',
                      color: 'var(--primary-orange)',
                      marginBottom: '15px'
                    }}>
                      {item.percentage}
                    </div>
                  )}
                  <p style={{ fontSize: '1.1rem', lineHeight: '1.7' }}>
                    {item.text}
                  </p>
                </div>
              ))}
            </div>
          </div>

          <div className="section-separator"></div>

          {/* Morocco Situation */}
          <div style={{ marginBottom: '60px', direction: 'ltr' }}>
            <h3 style={{
              fontSize: '2.5rem',
              marginBottom: '35px',
              textAlign: 'center',
              color: 'var(--white)',
              direction: 'ltr'
            }}>
              ⴰⴷⴷⴰⴷ ⴳ ⵍⵎⵖⵔⵉⴱ
            </h3>

            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
              gap: '30px',
              marginBottom: '40px'
            }}>
              {/* Most Vulnerable Groups */}
              <div style={{
                background: 'var(--primary-black)',
                padding: '35px',
                borderRadius: '15px',
                border: '2px solid rgba(255, 107, 53, 0.3)',
                direction: 'ltr',
                textAlign:'left'
              }}>
                <h4 style={{
                  fontSize: '1.8rem',
                  marginBottom: '20px',
                  color: 'var(--primary-orange)',
                  direction: 'ltr',
                    textAlign:'left'
                }}>
                  ⵉⵙⵎⵉⵍⵏ ⴱⴰⵀⵔⴰ ⵉⵜⵜⵎⵏⴰⵍⴰⵏ ⵜⵉⴽⵕⴹⵉ ⵜⴰⵎⵓⵟⵟⵓⵏⵜ
                </h4>
                <div style={{ fontSize: '1.1rem', lineHeight: '2' }}>
                  <p style={{ marginBottom: '10px' }}>• <strong>16%</strong> ⵜⵉⵡⵜⵎⵉⵏ ⴳ ⵜⵎⵏⴰⴹⵉⵏ ⵜⵉⵖⵔⵎⴰⵏⵉⵏ</p>
                  <p style={{ marginBottom: '10px' }}>• <strong>29%</strong> ⵜⵉⵔⴱⴰⵜⵉⵏ ⵏⴳⵔ 15 ⴷ 19 ⵏ ⵓⵙⴳⴳⵯⴰⵙ</p>
                  <p style={{ marginBottom: '10px' }}>• <strong>25%</strong> ⵜⵉⵡⵜⵎⵉⵏ ⵏⵏⵉ ⴷⴰⵔ ⵉⵍⵍⴰ ⵓⵙⵡⵉⵔ ⴰⵏⵎⵍⴰⵏ ⵢⴰⵜⵜⵓⵢⵏ</p>
                  <p style={{ marginBottom: '10px' }}>• <strong>30%</strong> ⵜⵉⵄⵣⵔⵉⵢⵉⵏ</p>
                  <p>• <strong>36%</strong> ⵜⵉⵎⵃⴹⴰⵕⵉⵏ</p>
                </div>
              </div>

              {/* Perpetrator Identity */}
              <div style={{
                background: 'var(--primary-black)',
                padding: '35px',
                borderRadius: '15px',
                border: '2px solid rgba(255, 107, 53, 0.3)',
                direction: 'ltr',
                  textAlign:'left'
              }}>
                <h4 style={{
                  fontSize: '1.8rem',
                  marginBottom: '20px',
                  color: 'var(--primary-orange)',
                  direction: 'ltr'
                }}>
                  ⵜⴰⵎⴰⴳⵉⵜ ⵏ ⵉⵎⴰⴷⵓⵜⵏ
                </h4>
                <div style={{ fontSize: '1.1rem', lineHeight: '2' }}>
                  <p style={{ marginBottom: '10px' }}>• <strong>73%</strong> ⵉⵔⴳⴰⵣⵏ ⵓⵔ ⵉⵜⵜⵡⴰⵙⵙⴰⵏⵏ</p>
                  <p style={{ marginBottom: '10px' }}>• <strong>4%</strong> ⵉⵎⴷⵔⴰⵡⵏ ⵏ ⵖⵉⵍⴰⴷ ⵏⵖ ⵡⵉⵏ ⵉⵣⵔⵉ</p>
                  <p style={{ marginBottom: '10px' }}>• <strong>4%</strong> ⵙⴳ ⵉⴳⵎⴰⵎⵏ ⵏ ⵜⵡⵊⴰ</p>
                  <p style={{ marginBottom: '10px' }}>• <strong>4%</strong> ⵉⵎⴷⴷⵓⴽⴽⴰⵍ ⵏ ⵜⵖⵓⵔⵉ ⵏⵖ ⵜⴰⵡⵓⵔⵉ</p>
                  <p>• <strong>4%</strong> ⵉⵎⴷⴷⵓⴽⴽⴰⵍ</p>
                </div>
              </div>

              {/* Reporting Problem */}
              <div style={{
                background: 'var(--primary-black)',
                padding: '35px',
                borderRadius: '15px',
                border: '2px solid rgba(255, 107, 53, 0.3)',
                direction: 'ltr',
                  textAlign:'left'
              }}>
                <h4 style={{
                  fontSize: '1.8rem',
                  marginBottom: '20px',
                  color: 'var(--primary-orange)',
                  direction: 'ltr'
                }}>
                  ⵜⴰⵎⵓⴽⵔⵉⵙⵜ ⵏ ⵓⵙⵉⵡⴹ
                </h4>
                <div style={{ fontSize: '1.1rem', lineHeight: '2' }}>
                  <div style={{
                    padding: '20px',
                    background: 'rgba(255, 107, 53, 0.1)',
                    borderRadius: '10px',
                    marginBottom: '15px',
                    textAlign: 'center'
                  }}>
                    <div style={{ fontSize: '3rem', fontWeight: '700', color: 'var(--primary-orange)' }}>
                      11%
                    </div>
                    <p>ⵙⴳ ⵜⵏⵖⵎⴰⵙⵉⵏ ⴽⴰ ⴰⴷ ⵉⵙⵙⵉⵡⵉⴹⵏ ⵅⴰⵜⵜ ⵜⴽⵕⴹⵉ ⵜⴰⵎⵓⵟⵟⵓⵏⵜ</p>
                  </div>
                  <div style={{
                    padding: '20px',
                    background: 'rgba(255, 107, 53, 0.1)',
                    borderRadius: '10px',
                    textAlign: 'center'
                  }}>
                    <div style={{ fontSize: '3rem', fontWeight: '700', color: 'var(--primary-orange)' }}>
                      8%
                    </div>
                    <p>ⴽⴰ ⴰⴷ ⵉⵜⵜⴰⵙⵉⵏ ⵜⵉⵎⴳⴳⵉⵜⵉⵏ ⵜⵓⵍⴳⵉⵏⵉⵏ</p>
                  </div>
                </div>
              </div>
            </div>

            <div style={{
              background: 'linear-gradient(135deg, rgba(255, 107, 53, 0.15), rgba(255, 133, 85, 0.08))',
              padding: '35px',
              borderRadius: '15px',
              border: '2px solid rgba(255, 107, 53, 0.3)',
              textAlign: 'center',
              marginTop: '30px',
              direction: 'ltr'
            }}>
              <p style={{ fontSize: '1.3rem', lineHeight: '2', color: 'var(--text-light)' }}>
              ⴰⵔ ⵜⵜⵉⵎⵖⵓⵔⵏⵜ ⵜⵓⴽⵢⴰⵜⵉⵏ ⵜⵉⵎⵓⵟⵟⵓⵏⵉⵏ ⵎⴳⴰⵍ ⵜⵉⵡⵜⵎⵉⵏ ⵉⵍⴰⵏ ⵜⵉⵍⵉⵜ ⵉⴼⴰⵡⵏ ⴳ ⵓⵙⴰⵢⵔⴰⵔ ⴰⵎⴰⵜⴰⵢ, ⵙⵍⴰⵡⴰⵏ ⴰⴽⴽⵯ ⵜⵉⵏⵏⴰ ⵉⵙⵡⵓⵔⵉⵏ ⴳ ⵉⴳⵔⴰⵏ ⵏ ⵜⴰⵏⵖⵎⴰⵙⵜ ⴷ ⵜⴰⵙⵔⵜⵉⵜ ⴷ ⵉⵣⵔⴼⴰⵏ. ⴰⵎⵓⵏⵜ ⴳ ⵜⵉⴷⵓⵜⵉⵏ ⴰⴷ <strong style={{ color: 'var(--primary-orange)' }}>ⴰⵙⵉⵙⵙⵏ, ⴰⵙⴷⵉⴷⴷⵉ, ⴰⵙⵏⵓⵃⵢⵓ, ⵜⵉⴽⵕⴹⵉ ⵜⴰⵎⵉⵡⴰⵏⵜ, ⴰⵥⵍⵍⴻⵍ, ⴷ ⵜⵉⴽⵕⴹⵉ ⵜⴰⵡⵙⵢⴰⵏⵜ</strong>; ⴳⴰⵏⵜ ⵜⵉⴷⵓⵜⵉⵏ ⵉⵜⵜⵟⵟⴰⵚⵏ ⴰⵣⵔⴼ ⵏ ⵜⵎⵖⴰⵔⵜ ⴳ ⵜⴷⵔⴼⵉ ⵏ ⵓⵡⵏⵏⵉ ⴷ ⵜⴷⵔⴰⵡⵜ ⴳ ⵜⵓⴷⵔⵜ ⵜⴰⵎⴰⵜⴰⵢⵜ.
              </p>
            </div>
          </div>

          <div className="section-separator"></div>

          {/* Campaign Organizer */}
          <div style={{ marginTop: '60px', marginBottom: '60px', direction: 'ltr' }}>


            <div style={{
              background: 'var(--primary-black)',
              padding: '50px 40px',
              borderRadius: '20px',
              border: '2px solid var(--primary-orange)',
              direction: 'ltr'
            }}>
              <h4 style={{
                fontSize: '2.2rem',
                marginBottom: '25px',
                color: 'var(--primary-orange)',
                textAlign: 'center',
                direction: 'ltr'
              }}>
                ⵓⵔ ⴰⴷ ⵏⴼⵉⵙⵙ ⵅⴼ ⵜⴽⵕⴹⵉ 2025
              </h4>

              <div style={{
    fontSize: '1.15rem',
    lineHeight: '2',
    color: 'var(--text-light)',
    justifySelf: 'center',
    direction: 'ltr'
  }}>

              <p style={{ marginBottom: '20px' }}>
  ⴰⵎⵣⵉⵣⵣⵍ ⴰⵏⴰⵎⵓⵔ ⵉⵙⵙⵏⵜⵉ <strong style={{ color: 'var(--primary-orange)' }}>ⵓⵙⵇⵇⵉⵎ ⴰⵏⴰⵎⵓⵔ ⵏ ⵉⵣⵔⴼⴰⵏ ⵏ ⵓⴼⴳⴰⵏ</strong> ⵉ ⵓⵙⴱⴷⴷⵉ ⵏ ⵜⴽⵕⴹⵉ ⵎⴳⴰⵍ ⵜⵉⵡⵜⵎⵉⵏ ⴷ ⵜⵔⴱⴰⵜⵉⵏ.
</p>


                <p>
                ⴰⵎⵣⵉⵣⵣⵍ ⵏⵏⵉ ⵔⴰⴷ ⵉⵎⵓⴷⴷⵓ ⵙ ⵜⵎⵏⴰⴹⵉⵏ ⵏ ⵜⴳⵍⴷⵉⵜ ⵃⵎⴰ ⴰⴷ ⵉⵙⵙⴼⵔⴽ ⵙ ⵜⴽⵕⴹⵉ ⵏⵏⴰ ⵜⵙⵙⵀⵡⴰⵏ ⵜⴰⵜⵉⴽⵏⵓⵍⵓⵊⵉⵜ ⵎⴳⴰⵍ ⵜⵉⵡⵜⵎⵉⵏ ⴷ ⵜⵔⴱⴰⵜⵉⵏ.
                </p>
                <p style={{ textAlign: 'center', marginTop: '20px', fontSize: '1.3rem', color: 'var(--primary-orange)' }}>
                  <strong>25 ⵏⵓⵡⴰⵏⴱⵉⵔ – 10 ⴷⵓⵊⴰⵏⴱⵉⵔ</strong>
                </p>
              </div>
            </div>
          </div>

          {/* Campaign Objectives */}
          <div style={{ marginBottom: '60px', direction: 'ltr' }}>
            <h3 style={{
              fontSize: '2.5rem',
              marginBottom: '35px',
              textAlign: 'center',
              color: 'var(--white)',
              direction: 'ltr'
            }}>
              ⵉⵏⵎⵎⴰⵍⵏ ⵏ ⵓⵎⵣⵉⵣⵣⵍ
            </h3>

            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
              gap: '30px'
            }}>
              {[
                {
                  icon: '🛡️',
                  title: 'ⴰⵙⵔⵙ ⵏ ⵓⵎⵙⵜⵉ',
                  desc: 'ⴰⵙⵎⵓⵏ ⵉ ⵓⵎⵙⵜⵉ ⵏ ⵉⵣⵔⴼⴰⵏ ⵏ ⵜⵡⵜⵎⵉⵏ ⴷ ⵜⵔⴱⴰⵜⵉⵏ ⴳ ⵓⵙⴰⵢⵔⴰⵔ ⴰⵎⵓⵟⵟⵓⵏ ⴷ ⵜⴰⵍⵍⵉⵜ ⵏ ⵜⵖⵉⵙⵜ ⵜⵉⵎⵍⵥⵉⵜ'
                },
                {
                  icon: '📚',
                  title: 'ⴰⵙⵙⵏ ⴷ ⵓⴳⵍⴷⵉ',
                  desc: 'ⴰⵙⵙⵉⵜⵢ ⵏ ⵜⵏⴰⵎⴰⵙⵜ ⵙ ⵓⵎⵓⴳⴳⴰⵔ ⵏ ⵜⴰⵜⵉⴽⵏⵓⵍⵓⵊⵉⵜ ⵏⵏⴰ ⵉⵙⵙⵀⵡⴰⵏ ⵜⵉⴽⵕⴹⵉ, ⴷ ⵓⵙⵎⵍⴰⵍ ⵏ ⵉⴱⵔⴷⴰⵏ ⵏ ⵓⴳⵍⴷⵉ'
                },
                {
                  icon: '🔔',
                  title: 'ⴰⵙⴼⵔⴽ ⴷ ⵓⵙⵙⵉⵜⵢ',
                  desc: 'ⴰⵙⵔⵙ ⵏ ⵜⴷⵍⵙⴰ ⵏ ⵜⵙⵍⴰⵎⵜ ⵜⴰⵎⵓⵟⵟⵓⵏⵜ ⴷ ⵜⴰⴼⵍⵙⵜ ⵏ ⴰⵏⵜⵉⵔⵏⵉⵜ ⴷ ⵜⴰⵜⵉⴽⵏⵓⵍⵓⵊⵉⵜ'
                },
                {
                  icon: '🔊',
                  title: 'ⴰⵙⵉⵡⴹ ⴷ ⵓⵙⵔⴰⵔⵙ ⵏ ⵓⴼⵙⵙⴰⵢ',
                  desc: 'ⴰⴳⴳⵯⵏ ⵏ ⵉⴷⵔⵉⵥⵏ ⵏ ⵜⴽⵕⴹⵉ ⵜⴰⵎⵓⵟⵟⵓⵏⵜ ⵉ ⵓⵙⵔⴰⵔⵙ ⵏ ⴰⵙⴰⵍⴰⵔ ⵏ ⵜⵉⵖⵔⵎⵜ ⴷ ⵓⴼⵙⵙⴰⵢ ⴷ ⵓⵙⵏⵔⵎⵍ ⵏ ⵓⵙⵉⵡⴹ'
                }
              ].map((objective, index) => (
                <div key={index} style={{
                  background: 'var(--primary-black)',
                  padding: '35px',
                  borderRadius: '15px',
                  border: '2px solid rgba(255, 107, 53, 0.3)',
                  textAlign: 'center',
                  transition: 'all 0.3s ease',
                  direction: 'ltr'
                }}>
                  <div style={{ fontSize: '3.5rem', marginBottom: '20px' }}>{objective.icon}</div>
                  <h4 style={{
                    fontSize: '1.6rem',
                    marginBottom: '15px',
                    color: 'var(--primary-orange)'
                  }}>
                    {objective.title}
                  </h4>
                  <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--text-light)' }}>
                    {objective.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>

          <div className="section-separator"></div>

          {/* Call to Action */}
          <div style={{ textAlign: 'center', marginTop: '60px', direction: 'ltr' }}>
            <h3 style={{
              fontSize: '2.5rem',
              marginBottom: '25px',
              color: 'var(--white)',
              direction: 'ltr'
            }}>
              ⴱⵔⵔⴽⴰⵎⵜ/ⴰⵜ ⴳ ⵉⵙⵔⴰⵙ ⵏ ⵓⵎⵣⵉⵣⵣⵍ
            </h3>
            <p style={{
              fontSize: '1.3rem',
              marginBottom: '30px',
              color: 'var(--text-light)',
              lineHeight: '1.8',
              direction: 'ltr'
            }}>
            ⵏⴱⵔⵔⴽ ⵙⵉⵔⵓⵏⵜ/ⵓⵏ ⴳ ⵉⵎⵣⵉⵣⵣⵍ ⴰⴷ, ⴰⵔ ⵏⵜⵜⴳⴰⵏⵏⴰ ⴰⵎⵢⴰⵖ ⵏⵏⵓⵏⵜ/ⵏⵏⵓⵏ ⴷ ⵜⵙⵓⵎⵔⵉⵏ ⵏⵏⵓⵏⵜ/ⵏⵏⵓⵏ ⵃⵎⴰ ⴰⴷ ⵜⴷⵔⵓⵎⵜ/ⵓⵎ ⴳ ⵢⴰⵏ ⵓⵙⴰⵢⵔⴰⵔ ⴰⵎⵓⵟⵟⵓⵏ ⵉⴼⵍⵙⵏ ⴷ ⵉⵖⴷⵎⵏ ⵉ ⵇⴰⵃ
            </p>

            <div style={{
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'center',
              gap: '20px'
            }}>


            </div>

            <p style={{
              fontSize: '1.2rem',
              marginTop: '40px',
              color: 'var(--text-light)',
              fontStyle: 'italic',
              direction: 'ltr'
            }}>
            ⴽⵓⵍⵍⵓ ⴰⵖ ⴰⴷ ⵏⵕⵥⵥ ⴰⵖⵔⴰⴱ ⵏ ⵉⴼⵙⵙⵜⵉ | ⴽⵓⵍⵍⵓ ⴰⵖ ⴰⴷ ⵏⴱⴷⴷ ⴳ ⵓⵎⵏⵉⴷ ⵏ ⵓⴱⵕⴱⴰⵢⵢⵓⵕ ⴰⵎⵓⵟⵟⵓⵏ ⵉⴼⵙⵙⵜⴰⵏ
            </p>
          </div>


        </div>
      </div>

  <Carousel />
    </div>
  );
}

export default AboutAMZ;
